import { BASE_QUERY, COMMON_QUERY_CONFIG, COMMON_VIDEO_QUERY_RULES_CONFIG, ruleNewsPlus } from './shared/configs';

const MAIN = {
  ...BASE_QUERY,
  query: {
    not: [...BASE_QUERY.query.not, ruleNewsPlus],
    and: [{ terms: { key: 'Keyword', value: ['USA250'] } }]
  }
};

const LEADING_AND_SUPPORT = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    and: [{ terms: { key: 'Keyword', value: ['USA250'] } }]
  }
};

const VIDEO_LIST = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'Keyword', value: 'USA250' } }]
  }
};

export { MAIN, LEADING_AND_SUPPORT, VIDEO_LIST };
